import { injectable } from 'tsyringe'
import { NotificationReportApiRepository } from '@/app/repositories/api/NotificationReportApiRepository'
import { NotificationReport } from '@/domain/entities/NotificationReports'

@injectable()
export class NotificationReportReportPresenter {
  private repository: NotificationReportApiRepository

  constructor(repository: NotificationReportApiRepository) {
    this.repository = repository
  }

  public loadNotificationReportReport(
    params: Object
  ): Promise<NotificationReport> {
    return this.repository.getAll(params)
  }
  // public loadExport(params: Object): Promise<Export> {
  //   return this.repository.getExport(params)
  // }
}
